"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasNonNullableKeys = void 0;
const hasNonNullableKeys = (obj, keys) => {
    return keys.every((k) => obj[k] !== undefined && obj[k] !== null);
};
exports.hasNonNullableKeys = hasNonNullableKeys;
